import numbro from 'numbro';

function formatNumber(value?, format?: string | numbro.Format): string {
  if (value == null || Number.isNaN(value) || (typeof value === 'string' && value.trim().length === 0)) {
    return numbro(0).format(format);
  }
  switch (format) {
    case '0,0': {
      return numbro(value).format({ thousandSeparated: true, mantissa: 0 });
    }
    case 'currencyWithoutSymbol':
    case '0,0.00': {
      return numbro(value).format({ thousandSeparated: true, mantissa: 2 });
    }
    case '0%': {
      return numbro(value).format({ mantissa: 0, output: 'percent' });
    }
    case '0,0%':
    case '0,00%': {
      return numbro(value).format({ thousandSeparated: true, mantissa: 0, output: 'percent' });
    }
    case 'currency':
      return numbro(value).format({ thousandSeparated: true, mantissa: 2, output: 'currency' });
    case 'fees': {
      // Entity fees supports up to 12 decimal places
      const showFullMantissa = value % 1 !== 0;
      return numbro(value).format({
        thousandSeparated: true,
        mantissa: showFullMantissa ? 12 : 2,
        trimMantissa: showFullMantissa,
      });
    }
    default:
      return numbro(value).format(format);
  }
}

export default formatNumber;
